import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importBorrowerSignup = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "BorrowerSignupContainer" */
                '@perpay-web/fintech/components/containers/BorrowerSignupContainer'
            ),
    );
